import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const ImporteFormGroup = ({ innerRef, iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('movimientoPresupuesto-select-proyecto', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='IMPORTE' htmlFor='movimientoPresupuesto-input-importe' md={12} />
      <Col md={12}>
        <Field name='importe'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              ref={innerRef}
              id='movimientoPresupuesto-input-importe'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteFormGroup)
